import { Pipe, PipeTransform } from '@angular/core';
import {
  COUNTY_LEVEL_LAYER,
  H3_RES5_LEVEL_LAYER,
  H3_RES7_LEVEL_LAYER,
  STATE_LEVEL_LAYER,
} from '../../../services/layer-store.service';

@Pipe({
  name: 'notAvailableWarningPipe',
})
export class NotAvailableWarningPipe implements PipeTransform {
  transform(level: string, formattedLayer: string): string {
    switch (level) {
      case H3_RES7_LEVEL_LAYER:
        return 'Looks like data is limited here. Zoom out to 5-mile cells for better insights.';
      case H3_RES5_LEVEL_LAYER:
        return 'Looks like data is limited here. Switch to the county level for better insights.';
      case COUNTY_LEVEL_LAYER:
        return 'Looks like data is limited here. Switch to the state level for better insights.';
      case STATE_LEVEL_LAYER:
        return `${formattedLayer} is not available here.`;
      default:
        throw new Error('Unknown level' + level);
    }
  }
}
